import { render, staticRenderFns } from "./CampaignWizard.vue?vue&type=template&id=4a16766f"
import script from "./CampaignWizard.vue?vue&type=script&lang=ts"
export * from "./CampaignWizard.vue?vue&type=script&lang=ts"
import style0 from "./CampaignWizard.vue?vue&type=style&index=0&id=4a16766f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports